/** Dev-only footer/body hint — copy includes localStorage commands for sparse HITL QA. */
function DevEnrichHint({ message }) {
  if (!message) return null;
  return <p className="text-xs leading-snug text-content-faint">{message}</p>;
}

export default DevEnrichHint;
